// src/components/Contact/index.tsx
import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';

import github from '../../assets/github.png';
import instagram from '../../assets/instagram.png';
import medium from '../../assets/medium.png';
import linkedin from '../../assets/linkedin.png';
import './style.css';

const Contact: React.FC = () => {
    return (
        <Container>
            <h3>Say hello!</h3>
            <a href="https://www.github.com/evanwchen" className="social_icon">
                <Image src={github} />
            </a>
            <a href="https://www.instagram.com/evanwchen" className="social_icon">
                <Image src={instagram} />
            </a>
            <a href="https://medium.com/@evanchen" className="social_icon">
                <Image src={medium} />
            </a>
            <a href="https://www.linkedin.com/in/evanwchen" className="social_icon">
                <Image src={linkedin} />
            </a>
        </Container>
    );
};

export default Contact;

